import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    margin: '10px 40px 24px'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  subTitle: {
    fontSize: '16px',
    color: '#545455',
    marginTop: '10px'
  }
}))
export default useStyles